import {ChangeDetectorRef, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {NavigationEnd, Router, RouterLink, RouterLinkActive} from '@angular/router';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {interval} from 'rxjs';
import moment from 'moment';
import {ModuleService} from '@app/shared/services';
import {CommonModule} from '@angular/common';
import {environment} from '@env/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  imports: [
    RouterLink,
    CommonModule,
    TranslatePipe,
    RouterLinkActive
  ],
  styleUrls: ['./sidebar.component.scss']

})
export class SidebarComponent implements OnInit {
  isActive = false;
  collapsed = false;
  showMenu = '';
  public count: any = {};
  pushRightClass = '';
  public userCredentials = JSON.parse(localStorage.getItem('user') ?? "{}");
  public menulist: any = [];
  public menu: any = {};
  public sub_menu: any = {};
  public now = new Date();
  public date: any;
  public user_id = this.userCredentials.user_id;
  @Output() collapsedEvent = new EventEmitter<boolean>();
  source = interval(10000);
  protected readonly environment = environment;

  constructor(private translate: TranslateService,
              public router: Router,
              public moduleServices: ModuleService,
              private cdr: ChangeDetectorRef) {
    this.translate.addLangs(['en',
      'fr', 'ur', 'es', 'it', 'fa', 'de']);
    this.translate.setDefaultLang('en');
    const browserLang = this.translate.getBrowserLang();
    if (browserLang != null) {
      this.translate.use(browserLang?.match(/en|fr|ur|es|it|fa|de/) ? browserLang : 'en');
    }

    this.router.events.subscribe(val => {
      this.findMenu()
      if (
        val instanceof NavigationEnd &&
        window.innerWidth <= 992 &&
        this.isToggled()
      ) {
        this.toggleSidebar();
      }
    });
  }


  findMenu() {
    if (this.menulist.find((moduleGroup: any) => this.router.url == moduleGroup.MODULE_GROUP_PATH))
      this.showMenu = ''
    else {
      const _menu = this.menulist.find(({
                                          sub_menu = [],
                                          MODULE_GROUP_PATH
                                        }: any) => sub_menu.find(({MODULE_PATH}: any) => this.router.url == MODULE_GROUP_PATH + MODULE_PATH))
      if (_menu) {
        this.showMenu = _menu.MODULE_GROUP_NAME;
        this.cdr.detectChanges();
      }
    }
  }

  ngOnInit() {
    this.isActive = false;
    this.collapsed = false;
    this.showMenu = '';
    this.loadModules();
    this.pushRightClass = 'push-right';
    this.formatDateTime(this.now);
    this.findMenu()
  }

  loadModules() {
    const sentData = {
      user_group: this.userCredentials.user_login,
      user_id: this.user_id
    };
    this.moduleServices.getModules(sentData).subscribe((result: any) => {
      window.scrollTo(0, 0);
      if (result['status'] == 'Success') {
        this.menulist = result['data'];
        this.menu = result['data'];
        this.findMenu()
        localStorage.setItem('modules', JSON.stringify(result['data']));
      }
    });
  }

  public formatDateTime(data: any) {
    if (this.now) {
      this.date = moment(this.now, 'yyyy-MM-D HH:mm.ss a').format('D-MM-Y HH:MM:ss');
    }
    if (data) {
      data = moment(data, 'yyyy-MM-D HH:mm.ss a').format('D-MM-Y HH:MM:ss');
      return data;
    }
  }

  addExpandClass(element: any) {
    if (element == this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }

  toggleCollapsed() {
    this.collapsed = !this.collapsed;
    this.collapsedEvent.emit(this.collapsed);
  }

  isToggled(): boolean {
    const dom: HTMLBodyElement | null = document.querySelector('body');
    return dom?.classList.contains(this.pushRightClass) as boolean;
  }

  toggleSidebar() {
    const dom: any = document.querySelector('body');
    dom.classList.toggle(this.pushRightClass);
  }
}
